import {Card} from "@material-ui/core";
import {CreateProps} from "react-admin";
import {CustomCreate} from "../../components/CustomCreate";
import {PresenceForm} from "./PresenceForm";

export const PresenceCreate = (props: CreateProps) => {
  return (
    <CustomCreate {...props} component={Card}>
      <PresenceForm />
    </CustomCreate>
  );
};
